import React, { useEffect } from 'react';
import { Col, Input } from 'antd';
import PropTypes from 'prop-types';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { ButtonAddEmailField, ButtonRemoveEmailField, ColIconRemove, ContainerAlternative } from './style';
import { useDictionaryTranslation } from '../../hooks/useDictionaryTranslation';

const AlternativeEmails = ({ onChange, dataEmails }) => {
  const { translate: t } = useDictionaryTranslation();

  const addEmailField = () => {
    onChange([...dataEmails, '']);
  };

  const removeEmailField = (index) => {
    onChange(dataEmails.filter((_, i) => i !== index));
  };

  const handleEmailChange = (index, value) => {
    const updatedEmails = [...dataEmails];
    updatedEmails[index] = value;
    onChange(updatedEmails);
    return updatedEmails;
  };

  useEffect(() => {
    if (dataEmails?.length) {
      onChange(dataEmails);
    } else {
      onChange(['']);
    }
  }, [dataEmails]);

  return (
    <Col md={24}>
      <ContainerAlternative >
        {dataEmails?.map((email, index) => (
          <React.Fragment key={index}>
            <Col xs={23} md={23}>
              <Input
                type="email"
                placeholder={t('emailPlaceholder')}
                value={email}
                onChange={(e) => handleEmailChange(index, e.target.value)}
              />
            </Col>
            {dataEmails.length > 1 && (
              <ColIconRemove md={1}>
                <ButtonRemoveEmailField icon={<DeleteOutlined />} onClick={() => removeEmailField(index)} />
              </ColIconRemove>
            )}
          </React.Fragment>
        ))}
        <Col span={24}>
          <ButtonAddEmailField icon={<PlusOutlined />} onClick={addEmailField} />
        </Col>
      </ContainerAlternative>
    </Col>
  );
};

export default AlternativeEmails;

AlternativeEmails.propTypes = {
  dataEmails: PropTypes.array,
  onChange: PropTypes.func,
};
